import React from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';

import AlertItem from '../AlertItem';

export default function AlertsList(props) {
  const { alertsIds } = props;

  return alertsIds.map((id) => <AlertItem id={id} key={id} />);
}

AlertsList.propTypes = {
  alertsIds: PropTypes.instanceOf(List).isRequired,
};
